export default "__VITE_ASSET__Tuj8wRGH__"